/* eslint-disable import/no-default-export */
import Chance from 'chance';

import rightToWorkCredential from './RightToWorkCredential';
import rightToWorkOptions from './RightToWorkOptions';
const chance = new Chance();

export const mapCountryName = (id: number) => {
  switch (id) {
    case 3000:
      return 'All Australia';
    case 3001:
      return 'All New Zealand';
    case 3002:
      return 'All UK & Ireland';
    case 24469:
      return 'Hong Kong';
    case 24572:
      return 'Thailand';
    case 24500:
      return 'Malaysia';
    case 24553:
      return 'Singapore';
    case 24534:
      return 'Philippines';
    case 24473:
      return 'Indonesia';
    default:
      return 'All Australia';
  }
};

export const mapCountryCode = (id: number) => {
  switch (id) {
    case 3000:
      return 'AU';
    case 3001:
      return 'NZ';
    case 3002:
      return 'GB';
    case 24469:
      return 'HK';
    case 24572:
      return 'TH';
    case 24500:
      return 'MY';
    case 24553:
      return 'SG';
    case 24534:
      return 'PH';
    case 24473:
      return 'ID';
    default:
      return 'AU';
  }
};

export const getCountryIds = () =>
  chance.pickset(
    [
      3000, // Australia
      3001, // New Zealand
      3002, // United Kingdom
      24469, // Hong Kong
      24572, // Thailand
      24500, // Malaysia
      24553, // Singapore
      24534, // Philippines
      24473, // Indonesia
    ],
    chance.integer({ min: 1, max: 3 }),
  );

export default () => {
  const countryIds = getCountryIds();
  const getRightToWorkOptions = rightToWorkOptions();

  return countryIds.flatMap((countryId) => {
    const countryCode = mapCountryCode(countryId);
    const filteredRtwOptionsByCountryCode = getRightToWorkOptions.filter(
      (rtw) => rtw.country.countryCode === countryCode,
    );

    return filteredRtwOptionsByCountryCode.map((rtwOptionsByCountryCode) => {
      const countryName = rtwOptionsByCountryCode.country.name;
      const rightToWork = chance.pickone(rtwOptionsByCountryCode.options);
      const canVerify = Boolean(rightToWork.verificationUrl);

      return {
        id: chance.guid(),
        country: {
          countryCode,
          name: countryName,
        },
        type2: {
          id: rightToWork.id,
          description: rightToWork.description,
          formattedDescription: rightToWork.description,
        },
        isDeprecated: false,
        verificationUrl: rightToWork.verificationUrl,
        credential: canVerify
          ? rightToWorkCredential(rightToWork.description)
          : null,
      };
    });
  });
};
